const PATRIMOINE = {
  error: {
    codeRequiredIfNoMask: 'Le code est obligatoire si le masque {typePatrimoine} sur la société est vide',
    face: 'face',
    materiel: 'matériel',
    dispositif: 'dispositif',
    emplacement: 'emplacement',
    createMateriel: 'On ne peut créer un matériel que si le dispositif n\'est pas archivé',
    createFace: 'On ne peut créer une face que si son matériel n\'est pas archivé',
    createDispositif: 'On ne peut créer un dispositif que si son emplacement n\'est pas archivé',
    clientObligatoire: 'Le client est obligatoire',
    clientMustbeNull: 'Le client doit être null',
    clientMustbeNullForImport: 'Ligne {numLigne}: Le code client est obligatoire.',
    codeGenerationElementRequired: 'Le champ "{propriete}" est obligatoire pour la génération du code.',
    cantSwitchNumerique: 'On ne peut passer d\'un type face à un type numérique et vice-versa',
    codeGenerationProperties: {
      inseeCode: 'Code insee',
      zipCode: 'Code postal',
      dispositifType: 'La codification du type de dispositif',
      visibilite: 'Visible sur la',
      disposition: 'Disposition',
    },
    etatCannotBeASame: 'Impossible de créer une historique de l\'état car le patrimoine et/ou les enfants du patrimoine ont déjà l\'état auquel vous voulez les passer.',
  },
  warning: {
    simpleSelection: {
      face: 'Le patrimoine sélectionné n\'a pas de face',
      materiel: 'Le patrimoine sélectionné n\'a pas de matériel',
      dispositif: 'Le patrimoine sélectionné n\'a pas de dispositif',
    },
    multipleSelection: {
      face: 'Les patrimoines sans face n\'ont pas été sélectionnés ou sélectionnés partiellement',
      materiel: 'Les patrimoines sans matériel n\'ont pas été sélectionnés ou sélectionnés partiellement',
      dispositif: 'Les patrimoines sans dispositif n\'ont pas été sélectionnés ou sélectionnés partiellement',
    },
  },
  selectionState: {
    selected: 'Sélectionné',
    selectedPartially: 'Sélectionné patiellement',
    unselected: 'Non sélectionné',
  },
  patrimoineEtatHistorique: {
    title: 'Historique',
    tab: {
      creationTime: 'Date du changement',
      creatorUserId: 'Auteur du changement',
      etatAvant: 'Etat avant',
      etatApres: 'Etat après',
      commentaire: 'Commentaire',
    },
  },
};

export default PATRIMOINE;
